import validator from '../shared/validators/validator';

const SESSION_TOKEN = 'token';
const DRIVE_CREDENTIAL_CODE = 'driveCredentialCode';
const AUTHORITIES = 'authorities';
const INDEXES_HISTORY = 'indexesHistory';
const NOTIFICATION_CONFIG_AUTHORITY = 'hasNotificationConfigAuthority';
const NOTIFICATION_HAS_MENU = 'hasMenu';
const THEME = 'theme';

export default {
  name: 'store',

  saveToken(token) {
    sessionStorage.setItem(SESSION_TOKEN, token);
  },

  removeToken() {
    sessionStorage.removeItem(SESSION_TOKEN);
  },

  saveHasNotificationConfigAuthority(status) {
    sessionStorage.setItem(NOTIFICATION_CONFIG_AUTHORITY, status);
  },

  saveHasMenu(status) {
    sessionStorage.setItem(NOTIFICATION_HAS_MENU, status);
  },

  getHasNotificationConfigAuthorityValue() {
    return sessionStorage.getItem(NOTIFICATION_CONFIG_AUTHORITY);
  },

  getHasNotificationConfigAuthority() {
    return sessionStorage.getItem(NOTIFICATION_CONFIG_AUTHORITY) === 'true';
  },

  getNotificationHasMenu() {
    return sessionStorage.getItem(NOTIFICATION_HAS_MENU);
  },

  getHasMenu() {
    return sessionStorage.getItem(NOTIFICATION_HAS_MENU) === 'true';
  },

  saveIndexesHistory(indexesHistory) {
    sessionStorage.setItem(INDEXES_HISTORY, JSON.stringify(indexesHistory));
  },

  getToken() {
    return sessionStorage.getItem(SESSION_TOKEN);
  },

  getIndexesHistory() {
    return JSON.parse(sessionStorage.getItem(INDEXES_HISTORY));
  },

  saveDriveCredentialCode(driveCredentialCode) {
    sessionStorage.setItem(DRIVE_CREDENTIAL_CODE, driveCredentialCode || '');
  },

  getDriveCredentialCode() {
    return sessionStorage.getItem(DRIVE_CREDENTIAL_CODE);
  },

  saveAuthorities(authorities) {
    sessionStorage.setItem(AUTHORITIES, authorities);
  },

  getAuthorities() {
    return sessionStorage.getItem(AUTHORITIES);
  },

  saveMandatoryStorageToLocalStorage() {
    const MANDATORY_STORAGE = this.getMandatoryStorage();

    MANDATORY_STORAGE.forEach(({ key, getValue }) => {
      const sessionStorageValue = getValue();
      localStorage.setItem(key, sessionStorageValue);
    });
  },

  restoreMandatoryStorageFromLocalToSession() {
    const MANDATORY_STORAGE = this.getMandatoryStorage();

    Object.values(MANDATORY_STORAGE).forEach(({ key }) => {
      const localStorageValue = localStorage.getItem(key);

      if (validator.isFilled(localStorageValue)) {
        sessionStorage.setItem(key, localStorageValue);
      }
    });

    this.clearMandatoryLocalStorage();
  },

  clearMandatoryLocalStorage() {
    const MANDATORY_STORAGE = this.getMandatoryStorage();

    MANDATORY_STORAGE.forEach(({ key }) => {
      localStorage.clear(key);
    });
  },

  saveTheme(theme) {
    sessionStorage.setItem(THEME, theme || '');
  },
  getTheme() {
    return sessionStorage.getItem(THEME);
  },

  /**
  * Sessões obrigatórias da aplicação.
  *
  * @returns {Array<{ key: string, getValue: function(): * }>} Lista de objetos com a chave da sessão e uma função que retorna seu valor.
  */
  getMandatoryStorage() {
    return [
      { key: AUTHORITIES, getValue: () => this.getAuthorities() },
      { key: DRIVE_CREDENTIAL_CODE, getValue: () => this.getDriveCredentialCode() },
      { key: INDEXES_HISTORY, getValue: () => this.getIndexesHistory() },
      { key: NOTIFICATION_HAS_MENU, getValue: () => this.getNotificationHasMenu() },
      { key: NOTIFICATION_CONFIG_AUTHORITY, getValue: () => this.getHasNotificationConfigAuthorityValue() },
      { key: SESSION_TOKEN, getValue: () => this.getToken() },
    ];
  },
};
